module.exports = __webpack_public_path__ + "img/Verletzte_Person.1247406d.svg";